// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"93a03143","796":"ab72833c"}[chunkId] + ".chunk.js";
};